import React from "react";
import { DocumentAccessContentType } from "./models/DocumentAccessContentType";
import { FarOnlineAddon } from "./models/FarOnlineAddon";

interface DocumentAccessMainAreaProps {
  contentType: DocumentAccessContentType;
  mainAreaText: string;
  buttonHint: string;
  buttonText: string;
    linkUrl: string;
  farOnlinePackageOrAddons?: FarOnlineAddon[];
  showOnlyPackages: boolean;
  addonCheckoutUrl: string;
  logInReturnUrl?: string;
}

export const DocumentAccessMainArea = ({
  contentType,
  mainAreaText,
  buttonHint,
  buttonText,
    linkUrl,
  farOnlinePackageOrAddons,
  showOnlyPackages,
  addonCheckoutUrl,
  logInReturnUrl,
}: DocumentAccessMainAreaProps) => {
  const packageOrAddonButton = (item: FarOnlineAddon) => {
    if (item !== null) {
      return (
        <React.Fragment key={item.addonCode}>
          <a
            href={`${addonCheckoutUrl}/account/login?returnUrl=${addonCheckoutUrl}/varukorg?addonCode=${item.addonCode}`}
            target="_blank"
          >
            {item.text}
          </a>
        </React.Fragment>
      );
    }
    };

    const isExternalLink = !!linkUrl && /^https?:\/\//.test(linkUrl);

  return (
    
    <div className="document-access-modal__bottom-side">
      <div className="document-access-modal__bottom-content">
        <div className="mainAreaSection">
          <div dangerouslySetInnerHTML={{ __html: mainAreaText }} />
        </div>
        {(contentType === DocumentAccessContentType.NotLoggedIn ||
          contentType === DocumentAccessContentType.ExpiredTestPeriod || contentType === DocumentAccessContentType.MissingPackageOrExtension) && (
          <>
          
            <div className="document-access-modal__footer">
              <div className="document-access-modal__bottom-button">
                <a
                  title={buttonHint}
                  type="button"
                  href={linkUrl}
                  target={isExternalLink ? "_blank" : undefined}
                  rel={isExternalLink ? "noopener noreferrer" : undefined}
                  className={`${isExternalLink ? 'externalLink' : ''}`}
                >
                  {buttonText}
                </a>
              </div>
            </div>
          </>
        )}
      </div>
      
        {contentType === DocumentAccessContentType.NotLoggedIn && (
          <>
            <form
                action="/account/login"
                method="get"
            >
                <input type="hidden" name="returnurl" value={logInReturnUrl} />
                <div className="document-access-modal__loginlink"><p>Har du redan ett konto?</p>
            
                <button type="submit">
                  <span>Logga in</span>
                </button>
                </div>
              </form>
          </>
        )}
    </div>
  );
};
